<template>
  <div>
      
      <div style="display: flex; flex-direction: row; margin-top: 10px;">
            <div v-if="$store.getters.getPreferenceProps.customer_measurement_required" style="margin-right: 20px; text-align: left;">
                <span type="label">Estimated Size</span>
                <br>
                <el-select 
                
                    :disabled="profile_data.id>0 && !inline"
                    size="small"
                    v-model="profile_data.size_id" 
                    filterable>
                    <el-option
                        v-for="(data, index) in $store.getters.getTailoringSizeList.filter(t => (t.tailoring_category_id === item_category_id || t.tailoring_category_id === 0))"
                        :key="index"
                        :label="data.size_name"
                        :value="data.id">
                        <span style="float: left" v-html="data.size_name"></span>
                    </el-option>
                </el-select>
            </div>
            <div v-if="$store.getters.getPreferenceProps.customer_measurement_required" style="margin-right: 20px; text-align: left;">
                <span type="label">Measurement Type</span>
                <br>
                <el-select 
                    :disabled="profile_data.id>0 && !inline"
                    size="small"
                    v-model="profile_data.measurement_type">
                    <el-option
                        :label="'Body'"
                        :value="0">
                        <span style="float: left" v-html="'Body'"></span>
                    </el-option>
                    <el-option
                        :label="'Ready'"
                        :value="1">
                        <span style="float: left" v-html="'Ready'"></span>
                    </el-option>
                </el-select>
            </div>            
            <div style="margin-right: 20px; text-align: left;">
                <span type="label">Measured By</span>
                <br>
                <el-select 
                    :disabled="profile_data.id>0 && !inline"
                    size="small"
                    v-model="profile_data.measured_by_staff_id" 
                    filterable style="width: 250px; text-align: left;">
                    <el-option
                        v-for="(data, index) in $store.getters.getEmployeeMasterList.filter(t => t.active && t.can_take_measurement)"
                        :key="index"
                        :label="data.staff_name"
                        :value="data.id">
                        <span style="float: left" v-html="data.staff_name"></span>
                    </el-option>
                </el-select>
            </div>
            <div style="margin-right: 20px; text-align: left;" v-if="inline && $store.getters.getPreferenceProps.print_tailor_name_on_wo">
                <span type="label">Tailored By</span>
                <br>
                <el-select 
                    size="small"
                    v-model="profile_data.tailored_by_staff_id" 
                    filterable style="width: 250px; text-align: left;">
                    <el-option
                        v-for="(data, index) in $store.getters.getEmployeeMasterList.filter(t => t.active && t.is_production_member)"
                        :key="index"
                        :label="data.staff_name"
                        :value="data.id">
                        <span style="float: left" v-html="data.staff_name"></span>
                    </el-option>
                </el-select>
            </div>

            <div style="text-align: left;">
                <span type="label">Notes/Remarks</span>
                <br>
                <el-input @focus="$event.target.select()"
                    :disabled="profile_data.id>0 && !inline"
                    size="small"
                    style="width: 400px;"
                    v-model="profile_data.notes">
                </el-input>
            </div>
      </div>
      <div style="border-bottom: 1px solid #e2e2e2;">
          <span v-html="'&nbsp;'"></span>
      </div>
      <div v-if="$store.getters.getPreferenceProps.customer_measurement_required">
          <br>
          <el-table
          v-if="!$store.state.preferences.props.horizontal_measurement_form"
        :data="getMeasurementList"
        style="width: 100%">
        <el-table-column 
        prop="measurement_name"
        label="Measurement Name">
        </el-table-column>
        <el-table-column 
        prop="measurement_value"
        label="Value">
            <template slot-scope="scope">
                <el-select 
                    style="width: 100%;"
                    :readonly="profile_data.id>0 && !inline"
                    v-if="scope.row.measurement_value_fixed"
                    size="small"
                    @blur="addToTrialList(scope.row)"
                    @change="scope.row.measurement_instruction_image = data.measurement_instruction_image"
                    v-model="scope.row.measurement_value" 
                    filterable>
                    <el-option
                        v-for="(data, index) in scope.row.measurement_drop_down_list"
                        :key="index"
                        :label="data.measurement_value"
                        :value="data.measurement_value">
                        <span style="float: left" v-html="data.measurement_value"></span>
                    </el-option>
                </el-select>
                <el-input @focus="$event.target.select()"
                    v-else
                    @blur="addToTrialList(scope.row)"
                    :readonly="profile_data.id>0 && !inline"
                    size="small"
                    v-model="scope.row.measurement_value">
                </el-input>
            </template>
        </el-table-column>
        
        <el-table-column 
        label="Instructional Image" align="center">
            <template slot-scope="scope">
                
                <UploadFile 
                    :image_path="scope.row.measurement_instruction_image"
                    :image_width="25"
                    :hide_upload="true"
                />  
            </template> 
        </el-table-column>
       </el-table>

        <div v-else style="display: flex; flex-direction: row; flex-wrap: wrap;">

                <div 
                    v-for="(data, index) in getMeasurementList" 
                    :key="index" style="margin: 10px;">

                        <div style="display: flex; flex-direction: column; justify-content: center; align-items: center;">

                            <UploadFile 
                    :image_path="data.measurement_instruction_image"
                    :image_width="25"
                    :hide_upload="true"
                /> 

                            <span>
                                {{data.measurement_name}}
                            </span>
                            <el-select 
                                style="width: 100%;"
                                @blur="addToTrialList(data)"
                                :readonly="profile_data.id>0 && !inline"
                                v-if="data.measurement_value_fixed"
                                size="small"
                                v-model="data.measurement_value" 
                                filterable>
                                <el-option
                                    v-for="(data1, index1) in data.measurement_drop_down_list"
                                    :key="index1+'_option'"
                                    :label="data1.measurement_value"
                                    :value="data1.measurement_value">
                                    <span style="float: left" v-html="data1.measurement_value"></span>
                                </el-option>
                            </el-select>
                            <el-input 
                                @focus="$event.target.select()"
                                @blur="addToTrialList(data)"
                                v-else
                                :readonly="profile_data.id>0 && !inline"
                                size="small"
                                v-model="data.measurement_value">
                            </el-input>
                        </div>

                </div>

        </div>
      </div>
       
    
  </div>
</template>

<script>
export default {
    props: ['msmt_form', 'windowTitle', 'profile_id', 'measurement_list', 'profile_data', 'inline', 'item_category_id'],
    computed: {
        getMeasurementList() {
            if(this.inline) {
                return this.profile_data.measurement_field_list
            }
            return this.measurement_list
        }
    },
    methods: {
        addToTrialList(msmtData) {
            if(this.msmt_form) {
                let found = false

                this.msmt_form.forEach(element => {
                    if(element.id === msmtData.measurement_id) {
                        found = true
                    }
                })

                if(!found) {
                    this.msmt_form.push({
                        id: msmtData.measurement_id,
                        measurement_name: msmtData.measurement_name,
                        measurement_value: msmtData.measurement_value
                    })
                }                
            }
        }
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/CustomerMaster/Form/MeasurementProfile/MeasurementFieldList.vue